import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M20 2v6H6V6H4v4h10v5h2v8h-6v-8h2v-3H2V4h4V2"
}), 'ImagesearchRoller');